import { connect } from 'react-redux';
import { LeadMap } from '../presentation/LeadMap';

const mapStateToProps = (state, ownProps) => {
  const { navPageUrlsafe = 'all', navVariantUrlsafe = 'all'} = ownProps.location;

  return ({
    page: state.page,
    lead: state.lead,
    navPageUrlsafe,
    navVariantUrlsafe,
  });
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeadMap);



// WEBPACK FOOTER //
// ./scripts/containers/LeadContainer.jsx